module.exports = __webpack_public_path__ + "images/emoji/stuck_out_tongue_winking_eye.b1cb353858bbfb22b948.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/stuck_out_tongue_winking_eye.png
// module id = QuJV
// module chunks = 2